import type React from 'react'
import type { JSX } from 'react'
import type {
  AuthFormBoxAlignItems,
  AuthFormBoxJustifyContent,
  AuthFormBoxPadding,
  AuthFormBoxRowGap,
} from './AuthFormBox.h'

import {
  AuthFormBoxBackgroundColors,
  AuthFormBoxCorners,
  AuthFormBoxDirection,
  AuthFormBoxPaddings,
  AuthFormBoxRowGaps,
} from './AuthFormBox.h'
import { AuthFormBoxStyled } from './AuthFormBox.styled'

export interface IAuthFormBoxProps {
  children: React.ReactNode
  width?: number
  height?: number
  direction?: AuthFormBoxDirection
  justifyContent?: AuthFormBoxJustifyContent
  alignItems?: AuthFormBoxAlignItems
  rowGap?: AuthFormBoxRowGap
  padding?: AuthFormBoxPadding
  corners?: AuthFormBoxCorners
  backgroundColorDefault?: AuthFormBoxBackgroundColors
  errorMessage?: string
}

export const AuthFormBox = ({
  children,
  width = 0,
  height = 0,
  direction = AuthFormBoxDirection.Column,
  justifyContent,
  alignItems,
  rowGap = AuthFormBoxRowGaps.SIZE_0,
  padding = AuthFormBoxPaddings.SIZE_0,
  corners = AuthFormBoxCorners.CORNERS_10,
  backgroundColorDefault = AuthFormBoxBackgroundColors.BACKGROUND_DARK,
  // errorMessage = '',
}: IAuthFormBoxProps): JSX.Element => (
  <AuthFormBoxStyled
    width={width}
    height={height}
    direction={direction}
    justifyContent={justifyContent}
    alignItems={alignItems}
    rowGap={rowGap}
    padding={padding}
    corners={corners}
    backgroundColorDefault={backgroundColorDefault}
  >
    {children}
  </AuthFormBoxStyled>
)

AuthFormBox.displayName = 'AuthFormBox'
